// useClassificationOptions.js
// Hook for filtering and managing option display logic

import {useMemo} from 'react';
import {TOP_OPTION_LIMIT} from '../../helpers/classificationOptions';

export const filterOptions = (options, query) => {
    if (!query) return options;
    const lower = query.toLowerCase();
    return options.filter((option) => (
        option.value.toLowerCase().includes(lower) || option.label.toLowerCase().includes(lower)
    ));
};

export const useTopOptions = (options, query, expanded, appliedValues = []) => {
    const filtered = useMemo(() => filterOptions(options, query), [options, query]);

    return useMemo(() => {
        const appliedSet = new Set(appliedValues);
        const appliedOptions = filtered.filter((option) => appliedSet.has(option.value));
        const nonAppliedOptions = filtered.filter((option) => !appliedSet.has(option.value));

        const limitedNonApplied = expanded ? nonAppliedOptions : nonAppliedOptions.slice(0, TOP_OPTION_LIMIT);
        const display = [...appliedOptions, ...limitedNonApplied];
        const hasMore = !expanded && nonAppliedOptions.length > limitedNonApplied.length;
        const canToggle = nonAppliedOptions.length > 0 && (hasMore || expanded);

        return {display, hasMore, canToggle};
    }, [filtered, expanded, appliedValues]);
};
